// A request.js response as the board's mutations want it: the JSON body when
// the server accepted the change, otherwise an Error carrying the server's
// messages ({ errors: [...] }) so the mutation's onError can show them.
export async function throwUnlessOk(response) {
  if (response.ok) return response.json

  let messages = []
  try {
    const body = await response.json
    if (Array.isArray(body?.errors)) messages = body.errors
    else if (body?.message) messages = [body.message]
  } catch (_) {
    // Not JSON: fall through to the generic message.
  }
  throw new Error(messages.length ? messages.join(' ') : `The change could not be saved (status ${response.statusCode}).`)
}

export function toastError(error) {
  if (window.toastr) window.toastr.error(error?.message || 'The change could not be saved.')
}
